export default "__VITE_ASSET__C2DuHB$v__"